import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router';

import { LoansPaths } from 'app/configs/routesConfig/loans';
import _ from 'lodash';

import { NBE_ENTITY_TABS_HREF } from '../EditEntityModal/EditEntityModal.hrefs';
import { checkIsNbeLandingRoute } from '../EditEntityModal/EditEntityModal.utils';

// Resolves the bare `borrowers/nbe` route "Go to field" lands a non-borrowing entity field on
// (checklists carry no NBE id) once the loan's NBEs have loaded: the only NBE opens in its
// drawer; with none or several, the user picks from the Borrowers list (LEN2-499).
const useNbeLandingRedirect = ({ isLoading, nonBorrowers }) => {
  const history = useHistory();
  const { applicationId, tab, subtab, entityId } = useParams();

  const isResolvable =
    checkIsNbeLandingRoute({ subtab, entityId }) && !isLoading && !_.isNil(nonBorrowers);
  const singleNbeId = isResolvable && nonBorrowers.length === 1 ? nonBorrowers[0].id : null;

  useEffect(() => {
    if (!isResolvable) {
      return;
    }

    const path = _.isNil(singleNbeId)
      ? LoansPaths.applicationManagement.generatePath({ applicationId, tab })
      : LoansPaths.applicationManagement.generatePath({
          applicationId,
          tab,
          subtab,
          entityId: singleNbeId,
          section: NBE_ENTITY_TABS_HREF.NBE_INFO,
        });

    history.replace(path);
  }, [applicationId, history, isResolvable, singleNbeId, subtab, tab]);
};

export default useNbeLandingRedirect;
